/**
 * Created by cc 19-10-26
 * 抖音待编渠道路由
 */
'use strict';
angular.module('editTrillPendingRouterModule', []).config([
    '$stateProvider',
    '$urlRouterProvider',
    function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('front.editctr.trill.pending', {
            url: '/pending?account&isOriginal&channelid', // accountid->账号
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/trill/pending/main.html',
                    controller: 'EditTrillPendingCtrl',
                },
            },
        });
    },
]);
